const KEY = "rl_cookie_consent";
const EVENT = "rl-consent-change";

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export function setConsent(marketing) {
  const value = { necessary: true, marketing: !!marketing, ts: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(value));
  applyConsent(value);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
}

function applyConsent(c) {
  if (c && c.marketing && typeof window.rlLoadMetaPixel === "function") window.rlLoadMetaPixel();
}

export function initConsent() {
  applyConsent(getConsent());
}

export function openPreferences() {
  window.dispatchEvent(new CustomEvent("rl-open-cookie-prefs"));
}

export function trackLead() {
  const c = getConsent();
  if (c && c.marketing && typeof window.fbq === "function") window.fbq("track", "Lead");
}

export const CONSENT_EVENT = EVENT;
